import { useState } from "react";
import style from "./style.module.scss";
import useFormat from "../../../hooks/utils/useFormat";
import { ModalAddTask } from "../../Modal";
import useWrapper from "../../../hooks/useWrapper";

export default function TasksPerDay(props) {
  const { tasks, setreload, reload } = props;
  const { formatDate } = useFormat();
  const { me } = useWrapper();

  const [modalSelect, setmodalSelect] = useState();

  return (
    <>
      <>
        {tasks?.map(__task => (
          <div
            className={`${style.task_box} ${me?.type === "Formando" ? style.task_formando : ""}`}
            data-status={__task.status}
            onClick={() => {
              setmodalSelect(__task.id);
            }}
          >
            <div>
              <span className={style.task_status}>{__task.status}</span>
            </div>
            <p className={style.task_name}>{__task.name}</p>
            <p className={style.task_description}>{__task.description}</p>
            {me.type === "Gestor" && <p className={style.task_group}>{__task.group}</p>}
            <p className={style.task_date}>{formatDate(__task.date_start, 5)}</p>
          </div>
        ))}
      </>
      {me.type === "Gestor" && (
        <ModalAddTask
          reload={() => {
            setreload(!reload);
          }}
          itemId={modalSelect}
          show={!!modalSelect}
          onHide={() => setmodalSelect(null)}
        />
      )}
    </>
  );
}
